export default {
  getOrder: {
    uri: 'orders/%order%',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getOrders: {
    uri: 'users/%user%/orders',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getInvoice: {
    uri: 'orders/%order%/documents/invoice/pdf',
    method: 'GETPDF',
    loading: true,
    subdomain: true,
    needsVerified: true
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/endpoints/order.js